var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 25,
    viewBox: "0 0 40 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 20H14.75C13.3576 20 12.0223 19.4469 11.0377 18.4623C10.0531 17.4777 9.5 16.1424 9.5 14.75C9.5 13.3576 10.0531 12.0223 11.0377 11.0377C12.0223 10.0531 13.3576 9.5 14.75 9.5C15.1892 9.49984 15.6269 9.55336 16.0531 9.65938",
    stroke: "#282829",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 12.5C15.5 11.3116 15.7824 10.1402 16.3239 9.0824C16.8655 8.02456 17.6506 7.11055 18.6147 6.41568C19.5787 5.72082 20.6941 5.265 21.8689 5.08578C23.0437 4.90656 24.2443 5.00907 25.3717 5.38488C26.4991 5.76068 27.5211 6.39901 28.3534 7.24726C29.1857 8.09552 29.8045 9.12941 30.1589 10.2637C30.5132 11.3981 30.5929 12.6004 30.3914 13.7716C30.1899 14.9427 29.713 16.0493 29 17",
    stroke: "#282829",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.072 15.6781L22.2501 12.5L25.4283 15.6781",
    stroke: "#282829",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.25 20V12.5",
    stroke: "#282829",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewMedia);
export default __webpack_public_path__ + "static/media/new-media.d90aa1449453776400df5a768e9e2d41.svg";
export { ForwardRef as ReactComponent };